import { c as _c } from "react/compiler-runtime";
import type { FC } from 'react';
import { cn } from '../../../libs/utils';
interface LogoFigmaProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

/**
 * @description Актуальный логотип из Figma (SVG, inline)
 * @example
 * <LogoFigma size="md" />
 *
 * @param {LogoFigmaProps} props
 * @returns {JSX.Element}
 */
export const LogoFigma: FC<LogoFigmaProps> = t0 => {
  const $ = _c(10);
  const {
    size: t1,
    className
  } = t0;
  const size = t1 === undefined ? "md" : t1;
  const sizePx = size === "sm" ? 20 : size === "lg" ? 40 : 28;
  let t2;
  if ($[0] !== sizePx) {
    t2 = Math.round(sizePx * 29 / 33);
    $[0] = sizePx;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== className) {
    t3 = cn("block", className);
    $[2] = className;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <path d="M32.4999 0H0L5.05068 8.89358H16.38L5.16047 28.4375H16.1402L32.4999 0Z" fill="#0091FF" />;
    t5 = <path d="M32.4999 0H21.5201L16.4695 8.89358L10.76 18.6655L16.2499 28.4375L32.4999 0Z" fill="#00B9FF" />;
    $[4] = t4;
    $[5] = t5;
  } else {
    t4 = $[4];
    t5 = $[5];
  }
  let t6;
  if ($[6] !== sizePx || $[7] !== t2 || $[8] !== t3) {
    t6 = <svg width={sizePx} height={t2} viewBox="0 0 33 29" fill="none" xmlns="http://www.w3.org/2000/svg" className={t3} aria-label="MySeven Logo" focusable="false" tabIndex={-1}>{t4}{t5}</svg>;
    $[6] = sizePx;
    $[7] = t2;
    $[8] = t3;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  return t6;
};
export type { LogoFigmaProps };